import {IntermediatePart} from "../../intermediatePart";

export default class Cabinet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.dbName = 'center Island';
    this.partId = 'center_island_cabinet';
    this.partName = 'Cabinet';
    this.translateId = "visualizer.kitchen.center_island.center_island_cabinet";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    return super.load_(dbFeature, new Cabinet());
  }

  changeLayout() {
    const layoutAbbreviation = this.getParent().layout.getCurrentLayoutAbbreviation();
    if (layoutAbbreviation.includes("I") && this.disabled) {
      this.disabled = false;
      this.disabledClick();
    }
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    centerIslandParent.relatedItems.forEach(relItem => {
      relItem.disabled = this.disabled;
    });
  }

  setDefault() {

    if (!this.tryToSetTheSameFeature(this.features)) {
      const layout = this.getParent().layout;
      if (layout.selectedLayoutFeatures[layout.type] && layout.selectedLayoutFeatures[layout.type][this.partId]) {
        this.activeFeature = this.getFeatureByPartName(layout.selectedLayoutFeatures[layout.type][this.partId]);
      } else {
        const existInSomeLayout = Object.keys(layout.selectedLayoutFeatures).find(layoutType => {
          return layout.selectedLayoutFeatures[layoutType] && layout.selectedLayoutFeatures[layoutType][this.partId];
        });
        if (existInSomeLayout) {
          this.activeFeature = this.getFeatureByPartName(layout.selectedLayoutFeatures[existInSomeLayout][this.partId]);
        }
      }
      if (!this.activeFeature) {
        this.activeFeature = this.features[0];
      }
    }
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CenterIsland.Cabinet;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
